module.exports = __webpack_public_path__ + "static/media/hall-PC.c02ef074.svg";